import React, { useEffect, useState } from "react";
import GoogleMapReact from "google-map-react";
import Shimmer from "./shimmer/Shimmer";

export default function DetailsMapComponent(props) {
  const [coords, setCoords] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!props.country) {
      setLoading(false);
      return;
    }

    const address = [
      props.property_name,
      props.municipality,
      props.district,
      props.state,
      props.country,
    ]
      .filter(Boolean)
      .join(", ");

    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address
    )}&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "OK" && data.results.length > 0) {
          const location = data.results[0].geometry.location;

          setCoords({
            lat: location.lat,
            lng: location.lng,
          });
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [
    props.property_name,
    props.municipality,
    props.district,
    props.state,
    props.country,
  ]);

  const handleApiLoaded = ({ map, maps }) => {
    if (!coords) return;

    new maps.Marker({
      position: coords,
      map,
    });
  };

  if (loading) {
    return (
      <Shimmer
        type="rectangle"
        width="100%"
        height="30vh"
        marginTop="0"
        borderRadius="12px"
      />
    );
  }

  if (!coords) {
    return (
      <div style={{ width: "100%", aspectRatio: "16 / 9", minHeight: "250px" }}>
        <iframe
          title="map"
          src="https://maps.google.com/maps?hl=en&q=dubai&z=14&output=embed"
          style={{ width: "100%", height: "100%", border: 0 }}
          loading="lazy"
        />
      </div>
    );
  }

  return (
    <div style={{ width: "100%", aspectRatio: "16 / 9", minHeight: "250px" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API_KEY }}
        center={coords}
        zoom={15}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={handleApiLoaded}
      />
    </div>
  );
}